import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\DeleteDossierController::__invoke
* @see app/Http/Controllers/Dossier/DeleteDossierController.php
* @route '/api/dossier/delete-dossier/{dossier}'
*/
const DeleteDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteDossierController.url(args, options),
    method: 'delete',
})

DeleteDossierController.definition = {
    methods: ["delete"],
    url: '/api/dossier/delete-dossier/{dossier}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\DeleteDossierController::__invoke
* @see app/Http/Controllers/Dossier/DeleteDossierController.php
* @route '/api/dossier/delete-dossier/{dossier}'
*/
DeleteDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return DeleteDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\DeleteDossierController::__invoke
* @see app/Http/Controllers/Dossier/DeleteDossierController.php
* @route '/api/dossier/delete-dossier/{dossier}'
*/
DeleteDossierController.delete = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteDossierController.url(args, options),
    method: 'delete',
})

export default DeleteDossierController